import {
  ListingRequest,
  PropertyTypeID,
} from '@klokhuis/core/ApiClient/Klokhuis';

export function getSearchFilterAppliedEventPayload(
  formState: Partial<ListingRequest>,
) {
  const activeFilters = {
    residentialLand: formState.listingTypeIds?.includes(
      PropertyTypeID.ResidentialLand,
    ),
    houseOrVilla: formState.listingTypeIds?.includes(
      PropertyTypeID.HouseOrVilla,
    ),
    farmLand: formState.listingTypeIds?.includes(PropertyTypeID.FarmLand),
    commercialLand: formState.listingTypeIds?.includes(
      PropertyTypeID.CommercialLand,
    ),
  };

  const filtersList: string[] = Object.keys(activeFilters).filter(key => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (activeFilters as any)[key];
  });

  return filtersList;
}
